export const CONVERT_LANG_MAP = {
  zh: 'cn',
};

export const LANG_MAP = {
  cn: 'zh',
};
